module.exports = __webpack_public_path__ + "static/media/event.0687acad.svg";